import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { VrstaTelefona  } from './vrsta-telefona';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-vrsta-telefona',
  templateUrl: './vrsta-telefona.component.html'
})
export class VrstaTelefonaComponent 
extends BaseModalContainer<VrstaTelefona> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaTelefona>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
